import { render, staticRenderFns } from "./check-in.vue?vue&type=template&id=150220ff&"
import script from "./check-in.vue?vue&type=script&lang=js&"
export * from "./check-in.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports